module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/SN-ddc19afc777197b486285fa78c57e4c7.png";